import { combineStrings } from 'assets/utils/data/String';
import InputType from 'models/enums/InputType';
import Model from 'models/Model';

export default class ProductRefundFillablePdfField
  extends Model<Model.IProductRefundFillablePdfField>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IProductRefundFillablePdfField>
{
  id: number;
  key: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  group?: string;
  label?: string;
  type?: InputType;
  propertyPath?: string;
  defaultValue?: string | number | boolean;

  productRefundDocumentId: number;

  constructor(
    data: Partial<Model.IProductRefundFillablePdfField> | Utils.FormData<Model.IProductRefundFillablePdfField>,
    language?: Locale.Languages
  ) {
    super({}, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: combineStrings(' | ', this.label, this.key),
      info: this.group,
      subtitle: this.type,
    };
  }
}
